__turbopack_context__.v({
  "providerButton": "ShareButton-module__tq9_KG__providerButton",
  "providerIcon": "ShareButton-module__tq9_KG__providerIcon",
  "shareButton": "ShareButton-module__tq9_KG__shareButton",
  "shareProvider": "ShareButton-module__tq9_KG__shareProvider",
  "title": "ShareButton-module__tq9_KG__title",
});
